import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#315fd8',
          'on-primary': '#ffffff',
          secondary: '#537efb',
          'on-secondary': '#ffffff',
          accent: '#83b2ff',
          'on-accent': '#030a1a',
          info: '#3b6feb',
          'on-info': '#ffffff',
          success: '#10b981',
          'on-success': '#ffffff',
          warning: '#f59e0b',
          'on-warning': '#030a1a',
          error: '#ef4444',
          'on-error': '#ffffff',
          background: '#f8fafd',
          'on-background': '#0d172e',
          surface: '#ffffff',
          'on-surface': '#0d172e',
          darknavy: '#030a1a',
          'on-darknavy': '#ffffff',
        },
      },
      dark: {
        colors: {
          primary: '#537efb',
          'on-primary': '#ffffff',
          secondary: '#83b2ff',
          'on-secondary': '#ffffff',
          accent: '#b0c9ff',
          'on-accent': '#030a1a',
          info: '#6a95f3',
          'on-info': '#ffffff',
          success: '#10b981',
          'on-success': '#ffffff',
          warning: '#f59e0b',
          'on-warning': '#030a1a',
          error: '#ef4444',
          'on-error': '#ffffff',
          background: '#030a1a',
          'on-background': '#fafaff',
          surface: '#05122e',
          'on-surface': '#fafaff',
          darknavy: '#030a1a',
          'on-darknavy': '#ffffff',
        },
      },
    },
  },
})
